import React from 'react';

const CTA: React.FC = () => {
  return (
    <section 
      className="py-20 bg-cover bg-center bg-no-repeat relative"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url('https://public.readdy.ai/ai/img_res/63e1f53063370fa864474b4b24a82e2d.jpg')`
      }}
    >
      <div className="container mx-auto px-6 text-center text-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Ready to Transform Your IT Operations?
          </h2>
          <p className="text-xl mb-12 leading-relaxed">
            Join 280,000+ organizations worldwide who trust ManageEngine for their IT management needs. 
            Start your free trial today and experience the difference.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-download-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold mb-2">Free Trial</h3>
              <p className="text-gray-200">Full access to premium features</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-customer-service-2-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold mb-2">Expert Support</h3>
              <p className="text-gray-200">24/7 dedicated customer success</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="w-12 h-12 bg-purple-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-rocket-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold mb-2">Quick Setup</h3>
              <p className="text-gray-200">Deploy in minutes, not months</p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              Start Free Trial
            </button>
            <button className="bg-transparent border-2 border-white hover:bg-white hover:text-gray-900 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              Schedule Demo
            </button>
            <button className="bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              Contact Sales
            </button>
          </div>

          <div className="mt-12 flex flex-wrap justify-center items-center gap-8 opacity-80">
            <div className="flex items-center space-x-2">
              <i className="ri-shield-check-line text-green-400"></i>
              <span>SOC 2 Certified</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-award-line text-yellow-400"></i>
              <span>Industry Awards</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-global-line text-blue-400"></i>
              <span>Global Presence</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-lock-line text-red-400"></i>
              <span>Enterprise Security</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;